package components.assemblyPortfolio

import it.neckar.commons.kotlin.js.getNotNull
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.assemblyPortfolio.ResolvedAssemblyPortfolio
import it.neckar.lizergy.model.configuration.quote.QuoteConfiguration
import it.neckar.lizergy.model.project.ResolvedProject
import react.*
import react.dom.*

val AssemblyPortfolioConfigurationOverview: FC<AssemblyPortfolioConfigurationOverviewProps> = fc("AssemblyPortfolioConfigurationOverview") { props ->
  val project = props::project.safeGet()
  val configuration = props::currentConfiguration.safeGet()
  val assemblyPortfolioToSave = props::assemblyPortfolioToSave.getNotNull()

  div {
    h2 { +"Laufkarte" }

    PlandatenOverview {
      attrs {
        this.project = project
        this.currentConfiguration = configuration
        this.assemblyPortfolioToSave = assemblyPortfolioToSave
      }
    }

    KundendatenOverview {
      attrs {
        this.project = project
        this.currentConfiguration = configuration
        this.assemblyPortfolioToSave = assemblyPortfolioToSave
      }
    }

    BasisdatenOverview {
      attrs {
        this.project = project
        this.currentConfiguration = configuration
        this.assemblyPortfolioToSave = assemblyPortfolioToSave
      }
    }

    KomponentenOverview {
      attrs {
        this.currentConfiguration = configuration
        this.assemblyPortfolioToSave = assemblyPortfolioToSave
      }
    }

    DachmontageOverview {
      attrs {
        this.currentConfiguration = configuration
        this.assemblyPortfolioToSave = assemblyPortfolioToSave
      }
    }
  }

}

external interface AssemblyPortfolioConfigurationOverviewProps : Props {
  var project: ResolvedProject
  var currentConfiguration: QuoteConfiguration?
  var assemblyPortfolioToSave: StateInstance<ResolvedAssemblyPortfolio>
}
